import { useColorModeValue } from "@chakra-ui/react";

import { DateObjectType } from "utils/DateObject";

import { ChakraText } from "components/ChakraText";
import { useGetThemeColors } from "ChakraTheme";

interface IProps {
  appointmentStartDate: DateObjectType;
}

const AppointmentStartDate = ({ appointmentStartDate }: IProps) => {
  const colors = useGetThemeColors();
  const expiredDateColor = useColorModeValue(colors.red[600], colors.red[200]);
  const actualDateColor = useColorModeValue(
    colors.green[600],
    colors.green[200]
  );
  return (
    <>
      {appointmentStartDate.isPast() ? (
        <ChakraText isTruncated color={expiredDateColor} fontWeight="bold">
          {appointmentStartDate.dateTimeFormat()}
        </ChakraText>
      ) : (
        <ChakraText isTruncated color={actualDateColor} fontWeight="bold">
          {appointmentStartDate.dateTimeFormat()}
        </ChakraText>
      )}
    </>
  );
};

export { AppointmentStartDate };
